import Splash from 'Pages/Splash';
import SecureDownload from 'Pages/SecureDownload';
import SiteHardPassword from 'Pages/SiteHardPassword';
import Convention from "Pages/Site/Convention";
import CapeTown from "../../../Pages/Site/CapeTown";
import Hotel from "../../../Pages/Site/Hotel";
import Programme from "../../../Pages/Site/Programme";
import FAQ from "../../../Pages/Site/FAQ";
import Gallery from "../../../Pages/Site/Gallery";
import Dashboard from "../../../Pages/Dashboard";
import Activities from "../../../Pages/Site/Activities";

export default [
    { path: '/', component: Dashboard, guards: ['auth'] },
    { path: '/secure-download/:id', component: SecureDownload},
    { path: '/site-hard-password', component: SiteHardPassword},
    { path: '/convention', component: Convention,  guards: ['auth'] },
    { path: '/cape-town', component: CapeTown, guards: ['auth'] },
    { path: '/hotel', component: Hotel, guards: ['auth'] },
    { path: '/programme', component: Programme, guards: ['auth'] },
    { path: '/faq', component: FAQ,  guards: ['auth'] },
    { path: '/gallery', component: Gallery,  guards: ['auth'] },
    { path: '/activities', component: Activities,  guards: ['auth'] },
];
